{
  "version": 1,
  "asset_id": "87a78bf0-85d5-4122-8361-326788f78e35",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/87a78bf0-85d5-4122-8361-326788f78e35/STI_Produktvideo-poster.jpg",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/87a78bf0-85d5-4122-8361-326788f78e35/STI_Produktvideo-poster.jpg",
  "original_filename": "STI_Produktvideo-poster.jpg",
  "size": 334030,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T07:30:26Z"
}
